import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  FieldInput,
  FieldButtonGroup,
  FieldInputNumber,
} from "../../../components";

const WithdrawalRequestBankAccountDetailsFields = (props) => {
  const { fields, filteredValues } = props;
  const BankAccountTypeOptions = [
    {
      label: "Savings",
      value: 1,
    },
    {
      label: "Checking",
      value: 2,
    },
  ];
  return (
    <Formik>
      <div>
        <p className="mt-20 plan-sub-heading">Bank Information</p>
        <Field
          size="md"
          isRequired
          name={fields.bankAccountNumber}
          label={"Bank account Number"}
          type="text"
          autoComplete="off"
          //value={getFormattedSsn(values[fields.bankAccountNumber])}
          value={filteredValues.bankAccountNumber}
          disabled={true}
          component={FieldInputNumber}
          maxLength="18"
        />
        <Field
          size="md"
          isRequired
          name={fields.accountHolderName}
          value={filteredValues.accountHolderName}
          label="Account Holder Name"
          type="text"
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          isRequired
          name={fields.bankAccountName}
          value={filteredValues.bankAccountName}
          label="Bank Name"
          disabled={true}
          // onChange={handleChange}
          component={FieldInput}
        />
        <Field
          size="md"
          isRequired
          name={fields.routingNumber}
          label={"Routing number"}
          type="text"
          autoComplete="off"
          value={filteredValues.routingNumber}
          // onChange={handleChange}
          disabled={true}
          component={FieldInputNumber}
        />
        <Field
          isRequired
          name={fields.bankAccountType}
          label={"Type of account"}
          options={BankAccountTypeOptions}
          selectedValue={filteredValues.bankAccountType}
          // onChange={(value) => {
          //   setFieldValue(fields.bankAccountType, value);
          // }}
          disabled={true}
          value={filteredValues.bankAccountType}
          component={FieldButtonGroup}
          size="sm"
        />
      </div>
    </Formik>
  );
};

export default WithdrawalRequestBankAccountDetailsFields;
